export class CoordsWithName {
  constructor(
    public name: string,
    public lng: number,
    public lat: number
  ) { }
}
